import { useMemo } from 'react';

import { NotificationCenterItem } from 'react-toastify/addons/use-notification-center';

import { isEmpty } from '@hsp/utilities';

import { INotification } from '@c/notifications/types';

export const useIsNotificationEmpty = (
  notifications: NotificationCenterItem<INotification>[],
  unreadCount: number,
  showUnreadOnly: boolean
) => {
  return useMemo(
    () => isEmpty(notifications) || (unreadCount === 0 && showUnreadOnly),
    [notifications, showUnreadOnly, unreadCount]
  );
};
